<template>
  <v-container fluid>
    <h1 class="headline mt-2 mb-2">Admin/Agent User Management</h1>

    <v-layout v-if="!isAssetWise" wrap>
      <v-flex xs12 :sm6="selectedGroup" class="pa-1">
        <v-layout class="mb-2">
          <v-flex>
            <h2 class="title grey--text mt-2">Group</h2>
          </v-flex>
          <add-admin-group @addGroup="addGroup"></add-admin-group>
        </v-layout>

        <template v-if="groups && groups.length > 0">
          <v-card>
            <template v-for="(group, gindex) in groups">
              <div :key="`group_${group.id}`" class="pa-3">
                <v-layout>
                  <v-flex>
                    <div class="font-weight-bold">
                      {{ group.groupname }}
                    </div>
                    <div class="caption">
                      {{ group.groupdescription ? group.groupdescription : '&nbsp;' }}
                    </div>
                  </v-flex>
                  <edit-admin-group
                    :key="'group_' + group.id + '_' + gindex"
                    v-model="groups[gindex]"
                    @editGroup="editGroup"
                  ></edit-admin-group>

                  <v-btn
                    fab
                    small
                    color="primary"
                    outline
                    class="mx-1 my-0"
                    @click="onDeleteGroup(group)"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>

                  <v-icon class="mt-2 ml-2" style="cursor: pointer" @click="selectedGroup = group">
                    arrow_forward_ios
                  </v-icon>
                </v-layout>
              </div>
              <v-divider v-if="groups.length - 1 != gindex" :key="`group_divider_${group.id}`" />
            </template>
          </v-card>
        </template>
        <div v-else class="text-xs-center grey lighten-3 py-3" style="border-radius: 10px">
          No data available
        </div>
      </v-flex>
      <v-flex v-if="selectedGroup" xs12 :sm6="selectedGroup" class="pa-1">
        <v-layout class="mb-2">
          <v-flex>
            <h2 class="title grey--text mt-2">{{ selectedGroup.groupname }} Group</h2>
          </v-flex>
          <add-admin-sub-group
            :group="selectedGroup"
            @addSubGroup="addSubGroup"
          ></add-admin-sub-group>
        </v-layout>

        <template v-if="filterSubGroups && filterSubGroups.length > 0">
          <v-card>
            <template v-for="(subgroup, gindex) in filterSubGroups">
              <div :key="`group_${subgroup.id}`" class="pa-3">
                <v-layout>
                  <v-flex>
                    <div class="font-weight-bold">
                      {{ subgroup.subgroupname }}
                    </div>
                    <div class="caption">
                      {{ subgroup.subgroupdescription ? subgroup.subgroupdescription : '&nbsp;' }}
                    </div>
                  </v-flex>
                  <edit-admin-sub-group
                    v-model="filterSubGroups[gindex]"
                    :group="selectedGroup"
                    @editSubGroup="editSubGroup"
                  ></edit-admin-sub-group>

                  <v-btn
                    fab
                    small
                    color="primary"
                    outline
                    class="mx-1 my-0"
                    @click="onDeleteSubGroup(subgroup)"
                    ><v-icon>delete</v-icon></v-btn
                  >
                </v-layout>
              </div>
              <v-divider
                v-if="filterSubGroups.length - 1 != gindex"
                :key="`group_divider_${subgroup.id}`"
              />
            </template>
          </v-card>
        </template>
        <div v-else class="text-xs-center grey lighten-3 py-3" style="border-radius: 10px">
          No data available
        </div>
      </v-flex>
    </v-layout>

    <div class="pa-1 mt-4">
      <v-layout class="mb-2">
        <v-flex>
          <h2 class="title grey--text mt-2">Admin Users</h2>
        </v-flex>
        <add-user @addUser="onAddUser"></add-user>
      </v-layout>

      <v-data-table
        :headers="headers"
        :pagination.sync="pagination"
        :items="admins"
        class="elevation-1"
        hide-actions
      >
        <template #items="props">
          <td>{{ props.index + 1 }}</td>
          <td>{{ props.item.name }}</td>
          <td>
            <template v-if="props.item.type == 'admin'">
              <change-password :userid="props.item.adminid"></change-password>
            </template>
          </td>
          <template v-if="!isAssetWise">
            <td>{{ props.item.groupname }}</td>
            <td>{{ props.item.subgroupname }}</td>
          </template>
          <td style="white-space: nowrap">
            <template v-if="!loadingAgentGroup && !loadingAgentSubGroup">
              <edit-user
                v-if="!isAssetWise"
                :key="props.index + '_' + props.item.adminid"
                v-model="props.item"
                @editUser="onEditUser"
              ></edit-user>
            </template>
            <v-btn
              fab
              small
              outline
              color="primary"
              :disabled="admins.length <= 1"
              @click="onDeleteUser(props.item)"
              ><v-icon>delete</v-icon></v-btn
            >

            <!-- <toggle-button
              :value="props.item.assign_status"
              :sync="true"
              @change="
                putassignstatusByadminid(props.item.adminid, props.item.assign_status)
                props.item.assign_status = !props.item.assign_status
              "
              :color="$vuetify.theme.success"
              :labels="{ checked: 'ON', unchecked: 'OFF' }"
            /> -->
          </td>
        </template>
      </v-data-table>
    </div>
  </v-container>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
const AddAdminGroup = () => import('./AddAdminGroup')
const EditAdminGroup = () => import('./EditAdminGroup')
const AddAdminSubGroup = () => import('./AddAdminSubGroup')
const EditAdminSubGroup = () => import('./EditAdminSubGroup')
const ChangePassword = () => import('./ChangePassword')
const AddUser = () => import('./AddUser')

const EditUser = () => import('./EditUser')
import { ToggleButton } from 'vue-js-toggle-button'

export default {
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      loadingAgentGroup: 'getLoadingAgentGroup',
      loadingAgentSubGroup: 'getLoadingAgentSubgroup'
    }),
    filterSubGroups() {
      if (this.selectedGroup) {
        return this.subgroups.filter((el) => {
          return el.admingroupid == this.selectedGroup.id
        })
      }
      return []
    },
    isAssetWise() {
      return ['assetwise'].includes(this.selectedBot.theme)
    },
    headers() {
      return [
        { text: 'No.', value: 'index', sortable: false },
        { text: 'Username', sortable: false },
        { text: 'Password', sortable: false },
        ...(!this.isAssetWise
          ? [
              { text: 'Group', sortable: false },
              { text: 'Sub Group', sortable: false }
            ]
          : []),
        { text: 'Action', sortable: false }
      ]
    }
  },
  components: {
    AddAdminGroup,
    EditAdminGroup,
    AddAdminSubGroup,
    EditAdminSubGroup,
    ChangePassword,
    AddUser,
    EditUser,
    ToggleButton
  },
  data() {
    return {
      loading: false,
      adminloading: [],
      admins: [],
      groups: [],
      subgroups: [],
      pagination: {
        rowsPerPage: 999
      },
      selectedGroup: null
    }
  },
  async mounted() {
    this.$store.dispatch('loading')
    this.loading = true
    try {
      var responseGroup = await this.getAdminGroup()
      var responseSubGroup = await this.getAdminSubGroup()
      var responseAdmin = await this.getAdmins()
      if (responseGroup.data) {
        this.groups = responseGroup.data
        this.$store.state.agentGroups = this.groups
      }
      if (responseSubGroup.data) {
        this.subgroups = responseSubGroup.data
        this.$store.state.agentSubgroups = this.subgroups
      }
      if (responseAdmin.data) {
        this.admins = responseAdmin.data
      }
    } catch (error) {
      console.error(error)
    }
    this.loading = false
    this.$store.dispatch('loading')
  },
  methods: {
    putassignstatusByadminid(adminid, status) {
      var vm = this
      var data = {
        pageid: this.selectedBot.pageid,
        assign_status: !status,
        adminid: adminid
      }
      this.adminloading.push(adminid)
      api.putassignstatusByadminid(data, (err, response) => {
        if (response.responsecode == 200) {
          var index = vm.adminloading.findIndex((el) => el == adminid)
          vm.adminloading.splice(index, 1)
          status = !status
        }
      })
    },
    async onAddUser(user) {
      this.$store.dispatch('loadAgents')
      var responseAdmin = await this.getAdmins()
      if (responseAdmin.data) {
        this.admins = responseAdmin.data
      }
    },
    async onEditUser(user) {
      this.$store.dispatch('loadAgents')
      var responseAdmin = await this.getAdmins()
      if (responseAdmin.data) {
        this.admins = responseAdmin.data
      }
    },
    getAdmins() {
      var data = {
        pageid: this.selectedBot.pageid
      }
      return new Promise((resolve, reject) => {
        api.getAdmins(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          if (this.isZwizAdmin()) {
            resolve(response)
          }

          resolve({
            data: response.data
              ? response.data.filter((admin) => {
                  return !admin.name.includes('zwiz')
                })
              : []
          })
        })
      })
    },
    getAdminGroup() {
      var data = {
        pageid: this.selectedBot.pageid
      }
      return new Promise((resolve, reject) => {
        api.getAdminGroup(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
    getAdminSubGroup() {
      var data = {
        pageid: this.selectedBot.pageid
      }
      return new Promise((resolve, reject) => {
        api.getAdminSubGroup(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
    addGroup(payload) {
      this.groups.push(payload)
      this.$store.dispatch('loadAgentGroups')
    },
    editGroup(payload) {
      var index = this.groups.findIndex((el) => {
        return el.id == payload.id
      })
      if (index != -1) {
        this.$set(this.groups, index, payload)
      }
      this.$store.dispatch('loadAgentGroups')
    },
    async onDeleteGroup(group) {
      var result = await this.$swal.fire({
        title: this.$t('Do you want to delete {name}?', {
          name: group.groupname.replace(/\<|\>/g, '')
        }),
        type: 'warning',
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true,
        showCancelButton: true
      })
      if (result.value) {
        await this.deleteGroup(group)
        var index = this.groups.findIndex((el) => {
          return el.id == group.id
        })
        if (index != -1) {
          this.groups.splice(index, 1)
          this.$store.dispatch('loadAgentGroups')
        }
      }
    },
    deleteGroup(data) {
      return new Promise((resolve, reject) => {
        var request = {
          id: data.id,
          pageid: this.selectedBot.pageid
        }
        api.deleteadmingroup(request, function (error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    addSubGroup(payload) {
      this.subgroups.push(payload)
      this.$store.dispatch('loadAgentSubGroups')
    },
    editSubGroup(payload) {
      var index = this.subgroups.findIndex((el) => {
        return el.id == payload.id
      })
      if (index != -1) {
        this.$set(this.subgroups, index, payload)
      }
      this.$store.dispatch('loadAgentSubGroups')
    },
    async onDeleteSubGroup(group) {
      var result = await this.$swal.fire({
        title: this.$t('Do you want to delete {name}?', {
          name: group.subgroupname.replace(/\<|\>/g, '')
        }),
        type: 'warning',
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true,
        showCancelButton: true
      })
      if (result.value) {
        await this.deleteSubGroup(group)
        var index = this.subgroups.findIndex((el) => {
          return el.id == group.id
        })
        if (index != -1) {
          this.subgroups.splice(index, 1)
          this.$store.dispatch('loadAgentSubGroups')
        }
      }
    },
    deleteSubGroup(data) {
      return new Promise((resolve, reject) => {
        var request = {
          id: data.id,
          pageid: this.selectedBot.pageid
        }
        api.deleteadminsubgroup(request, function (error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    async onDeleteUser(user) {
      var result = await this.$swal.fire({
        title: this.$t('Do you want to delete {name}?', {
          name: user.name.replace(/\<|\>/g, '')
        }),
        type: 'warning',
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true,
        showCancelButton: true
      })
      if (result.value) {
        this.$store.dispatch('loading')
        await this.deleteadminusers({ userid: user.adminid })
        if (this.$store.state.userid == user.adminid) {
          this.$store.dispatch('logout', null).then()
          if (this.user.type == 'admin') {
            this.$router.push('/' + this.currentLang + '/nigol')
          } else {
            this.$router.push('/' + this.currentLang + '/login')
          }
        }
        var responseAdmin = await this.getAdmins()
        if (responseAdmin.data) {
          this.admins = responseAdmin.data
        }
        this.$store.dispatch('loading')
      }
    },
    deleteadminusers(data) {
      return new Promise((resolve, reject) => {
        var request = {
          userid: data.userid,
          pageid: this.selectedBot.pageid
        }
        api.deleteadminusers(request, function (error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/Agentmanagement/Users.vue